<template>
  <div id="app">
    <div class="menu-box" v-if="screenWidth > 750">
      <div class="log-box">
        <img src="@/assets/logo.png" alt="">
        <span>Wuhan Yuyi Wuyou Technology Co., Ltd</span>
      </div>
      <div class="menu-item">
        <div @click="choiceMenu(0)" :class="(menuIndex === 0) ? 'choice' : ''">Home</div>
        <div @click="choiceMenu(1)" :class="(menuIndex === 1) ? 'choice' : ''">Product Introduction</div>
        <div @click="choiceMenu(2)" :class="(menuIndex === 2) ? 'choice' : ''">Product Core</div>
        <div @click="choiceMenu(3)" :class="(menuIndex === 3) ? 'choice' : ''">Company Introduction</div>
        <!-- <div @click="choiceMenu(4)" :class="(menuIndex === 4) ? 'choice' : ''">Menghapus data</div> -->
        <!-- <div @click="choiceMenu(4)" :class="(menuIndex===4)?'choice':''">Our Lending Partners</div> -->
        <!-- <div @click="choiceMenu(5)" :class="(menuIndex===5)?'choice':''">Privacy Policy</div>
        <div @click="choiceMenu(6)" :class="(menuIndex===6)?'choice':''">Partners</div> -->
      </div>
    </div>
    <div id='step_1' ref="step_1" class="ref-home"></div>

    <div class="banner-box" id='home' ref="home">
      <img src="../assets/banner.png" class="banner">
      <div class="app-name">
        The steps are clear and quick, with excellent security.
      </div>
    </div>

    <div id='step_2' ref="step_2"></div>
    <div class=" introduce-box">
      <div class=" title">Product Introduction</div>
      <div class="content">
        <div class="content-text">
          <div class="text-box">
            <div class="text">
              <p>1. Excellent security, attention and privacy protection</p>
              <div>Wuhan Yuyi Wuyou Technology Co., Ltd. attaches great importance to the security of information storage. The information entered by the user is only used for loan application, and the platform will never sell or disclose the user's personal information. We have taken multiple encryption measures.</div>
            </div>
          </div>
          <div class="text-box">
            <div class="text">
              <p>2. Convenient application and fast review</p>
              <div>You can complete the online loan application by submitting your identity certificate. The review will be completed within 30 minutes, and the loan funds will be received quickly to ensure that every application can be processed quickly</div>
            </div>
          </div>
          <div class="text-box">
            <div class="text">
              <p>3. Flexible quota and sufficient funds</p>
              <div>Flexible quota and rich financial products for you to choose from to meet your diverse funding needs. Whether it is personal consumption, education expenses or emergency assistance, we can provide a loan plan suitable for you.</div>
            </div>
          </div>
        </div>
        <img src="../assets/step_1.png" class="list-10">
      </div>
    </div>

    <div id="step_3" ref="step_3"></div>
    <div class="better">
      <div class=" title">Product Core</div>
      <div class="content">
        <img src="../assets/step_2.png" class="step_2">
        <div class="better-text">
          <p>Simple and fast loan application process</p>
          <div>You can easily apply for a loan with just a few clicks. The application process is intuitive and clear, avoiding the tediousness of traditional loan applications. The whole process only takes a few minutes.</div>
        </div>
        <div class="better-text">
          <p>It only takes a few minutes to complete the application</p>
          <div>Planning to buy new equipment or dealing with unexpected expenses, we provide a variety of loan options. Even if it is your first time to apply for a loan, our customer service will accompany you throughout the process.</div>
        </div>
        <img src="../assets/step_3.png" class="step_2"></img>
      </div>

    </div>
    <div id='step_4' ref="step_4"></div>
    <!-- <div class="privacy-box" @click="gotoPrivacy"> -->
    <div class="privacy-box">
      <div class="title">Company Introduction</div>
      <div class="content">
        Welcome to Wuhan Yuyi Wuyou Technology Co., Ltd., we are a company dedicated to providing innovative financial solutions, aiming to help every customer achieve their financial goals.
        We know that financial services are not only about numbers, but also closely related to everyone's dreams and lives. To this end, we continue to develop and upgrade our products to adapt to market changes and customer needs. Our goal is to eliminate the cumbersomeness and inconvenience in traditional financial services so that more people can easily obtain the financial support they need.
        Thank you for choosing Wuhan Yuyi Wuyou Technology Co., Ltd. Let us work together to move towards a better future and realize your dreams and goals!
      </div>
    </div>

    <div id='step_5' ref="step_5"></div>

    <div id='step_6' ref="step_6"></div>

    <div class="footer">
      <div class="flex-footer-content">
        <div class="box">
          <img src="@/assets/mail.png" class="mail-img">
          <div class="text">effg43534fdg@gmail.com</div>
        </div>
        <div class="box">
          <img src="@/assets/address.png" class="mail-img">
          <div class="text">Alamat: Room 1001, 4th Floor, Incubation Building, Hainan Ecological Software Park, High-tech Industrial Demonstration Zone, Old Town, Chengmai County, Hainan Province</div>
        </div>
      </div>
    </div>
    <div class="copyright">© Copyright by Hainan Aimu Technology Co., Ltd..</div>
    <div class="flex-box" v-if="msgDlg">
      <div class="msg-box">
        <div class="msg">
          <img src="../assets/title-err.png" class="err-img">
          {{ msg }}
        </div>
        <img src="../assets/close.png" class="close" @click="msgDlg = false">
      </div>
    </div>
  </div>
</template>

<script>
import privacy from "@/components/privacy";
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
import * as api from "@/api/api";
export default {
  name: 'App',
  components: {
    privacy,
    footerBox,
    menuBox
  },
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      mobile: '',
      password: '',
      code: '',
      msgDlg: false,
      msg: '',
      steps: 1,
      infoData: {},
      Time: 0,
      idcard: '',
      verifyIDCard: '',
      // $loading: useLoading
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    let item = this.$route.query.item
    console.log(item);
    if (item == 'partners') {
      this.$nextTick(() => {
        setTimeout(() => {
          this.choiceMenu(4)
        }, 1000);
      })
    }

  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 0: document.getElementById("step_1").scrollIntoView(); break;
        case 1: document.getElementById("step_2").scrollIntoView(); break;
        case 2: document.getElementById("step_3").scrollIntoView(); break;
        case 3: document.getElementById("step_4").scrollIntoView(); break;
        case 4: document.getElementById("step_5").scrollIntoView(); break;
        case 5: document.getElementById("step_6").scrollIntoView(); break;
        case 6: document.getElementById("step_7").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu
    },
    gotoPrivacy() {
      this.$router.push({
        path: "/Privacy",
      });
    },
    delSearch() {
      let data = {
        mobile: this.mobile,
        password: this.password
      }
      console.log(this.$loading);
      let loding = this.$loading.show({})
      api.delInfoSearch(data).then(res => {
        loding.hide()
        this.infoData = res.data
        this.steps = 2
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    candelete() {
      let data = {
        user_id: this.infoData.user_id
      }
      let loding = this.$loading.show({})
      api.delInfoCanDelete(data).then(res => {
        loding.hide()
        if (res.data.idcard) {
          this.verifyIDCard = res.data.idcard
          this.steps = 5
        } else {
          this.steps = 3
          this.Reenviar()
        }
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    verifyIdCard() {
      console.log(this.verifyIDCard);
      if (this.verifyIDCard == this.idcard) {
        this.steps = 3
        this.Reenviar()
      } else {
        this.msgDlg = true
        this.msg = 'Kartu ID yang dimasukkan salah dan verifikasi gagal.'
      }
    },
    Reenviar() {
      if (this.Time > 0) {
        return
      }
      this.Countdown(60)
      let data = {
        mobile: this.mobile
      }
      let loding = this.$loading.show({})
      api.delInfoSms(data).then(res => {
        loding.hide()
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    doDelete() {
      let loding = this.$loading.show({})
      let data = {
        mobile: this.mobile,
        code: this.code,
        user_id: this.infoData.user_id
      }
      api.delInfoDoDelete(data).then(res => {
        loding.hide()
        this.steps = 4
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    Countdown(time) {
      this.Time = time
      if (time <= 0) {
        return
      }

      setTimeout(() => {
        this.Countdown(time - 1)
      }, 1000);
    }
  }
}
</script>


<style lang="less">
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
